<template>
    <div class="notice-list-content">
        <Scroll :on-reach-bottom="handleReachBottom" :loading-text="tips">
            <Card dis-hover v-for="(item,index) in noticeList" :key="index" style="margin: 0 5px 5px 5px;height:75px">
                <div class="notice-content">
                    <span class="author-box">{{item.author}}</span>
                    <span class="title-box" @click="showDetail(item.id)">{{item.title}}</span>
                </div>
                <div class="notice-time">
                    {{item.pubTime}}
                </div>
            </Card>
        </Scroll>
    </div>
</template>
<style scoped>
    .notice-content {
        color: rgb(144, 185, 226);
    }

    .notice-time {
        color: rgb(145, 145, 145);
        font-size: 12px;
        padding-left: 240px;
    }

    .author-box {
        display: inline-block;
        width: 40px;
        height: 40px;
        background: lightgray;
        font-size: 9px;
        color: darkgray;
        border-radius: 50%;
        padding-top: 12px;
        font-weight: 600
    }

    .title-box {
        display: inline-block;
        width: 100px;
        height: 20px;
        margin-left: 30px;
        font-size: 15px;
    }

    .title-box:hover {
        cursor: pointer;
    }

    .ivu-card-body {
        padding: 5px !important;
    }
</style>

<script>
    export default {
        name: 'notice-content',
        data() {
            return {
                tips: '加载中',
            }
        },
        computed: {
            noticeList() {
                return $store.state.notice.noticeList.notice.list
            }
        },
        methods: {
            showDetail(v) {
                
            },
            handleReachBottom() {
                return new Promise(resolve => {
                    setTimeout(() => {
                        const last = this.noticeList[this.noticeList.length - 1];
                        for (let i = 1; i < 11; i++) {
                            this.noticeList.push(last + i);
                        }
                        resolve();
                    }, 2000);
                });
            },
            // handleNextDatas() {
            //     this.page++
            //     if (this.noticeList.length < this.totalCount) {
            //         this.tips = "加载中"
            //         noticeList({ page: this.page })
            //             .then(res => {
            //                 var nowdata = res.data.page.list;

            //                 this.noticeList.splice(this.noticeList.length, 0, ...nowdata)
            //             })
            //     } else {
            //         this.tips = "没有新数据了哦"
            //     }
            // },
        }
    }
</script>